/* ============================================================
   GP CART ACTIVITY — shows ONE short, true sales message per product.

   Candidates, all real:
     carts  "4 other shoppers have this in their cart"  (worker, or gp.in_carts metafield)
     stock  "Only 3 left in stock"                       (data-stock, from Liquid inventory)
     sold   "23 sold in the past 30 days"                 (worker, from real orders)
     label  "Halloween favourite"                         (data-label, the merchant's own words)
   The first one in the merchant's chosen order that is true wins. If none are,
   the element stays hidden — it never shows 0 and never invents a number.

   - Every element on the page (product page, sticky bar, 48 collection
     cards, cart drawer lines...) is collected and sent in ONE request.
   - Results are cached per product in sessionStorage for 60s, so the
     cart drawer re-rendering or moving between pages costs nothing.
   - The shopper's own cart is excluded server-side, so the cart number is
     always "other shoppers", never including you.
   - If the worker is down or slow, the messages that don't need it (low
     stock, labels) still show; the live ones simply don't.
   ============================================================ */
(function () {
  var cfg = readConfig();
  if (!cfg) return;

  /* Settings arrive as data-* attributes on this script's own <script> tag (theme.liquid).
     window.GPCartActivity is still honoured if something sets it explicitly. */
  function readConfig() {
    if (window.GPCartActivity && window.GPCartActivity.enabled) return window.GPCartActivity;
    var tag = document.querySelector('script[data-gp-cart-activity]');
    if (!tag) return null;
    var d = tag.dataset;
    var int = function (v, fallback) { var n = parseInt(v, 10); return isNaN(n) ? fallback : n; };
    return {
      enabled: true,
      source: d.source || 'endpoint',
      endpoint: d.endpoint || '',
      order: (d.order || 'carts,stock,sold,label').split(','),
      windowHours: int(d.windowHours, 6),
      minCount: int(d.minCount, 2),
      badgeMin: int(d.badgeMin, 5),
      textOne: d.textOne || '',
      textMany: d.textMany || '',
      textCart: d.textCart || '',
      textCard: d.textCard || '',
      textStock: d.textStock || '',
      textStockCard: d.textStockCard || '',
      sold: d.sold === 'true',
      soldDays: int(d.soldDays, 30),
      soldMin: int(d.soldMin, 3),
      textSold: d.textSold || '',
      textSoldCard: d.textSoldCard || '',
      animate: d.animate === 'true',
      cartToken: d.cartToken || ''
    };
  }

  var CACHE_KEY = 'gpCartActivity:v2';
  var TTL_MS = 60 * 1000;
  var BATCH_MS = 40;
  var MAX_IDS_PER_REQUEST = 50;
  var REQUEST_TIMEOUT_MS = 4000;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var endpoint = cfg.source === 'endpoint' ? (cfg.endpoint || '').replace(/\/+$/, '') : '';
  var cache = readCache();
  var queue = [];          // elements waiting for live data
  var inFlight = {};       // productId -> true while a request is running
  var failed = false;      // stop asking after a failure on this page view
  var flushTimer = null;

  /* ---------- cache: { productId: { c: carts, s: sold|null, t: time } } ---------- */
  function readCache() {
    try { return JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeCache() {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) { /* private mode etc. */ }
  }
  function cached(id) {
    var hit = cache[id];
    return hit && (Date.now() - hit.t) < TTL_MS ? hit : null;
  }

  /* ---------- the shopper's own cart token (excluded from counts) ---------- */
  function cartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    var raw = m ? decodeURIComponent(m[1]) : (cfg.cartToken || '');
    return raw.split('?')[0];
  }

  /* ---------- choosing the message ---------- */
  function num(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n;
  }

  // live = { c: carts, s: sold } from the worker, or null when unavailable.
  function choose(el, live) {
    var ctx = el.getAttribute('data-context');
    var preview = el.getAttribute('data-preview');
    var carts = el.hasAttribute('data-carts') ? num(el.getAttribute('data-carts')) : (live ? live.c : null);

    if (ctx === 'badge') {
      return carts !== null && carts >= cfg.badgeMin ? { kind: 'carts' } : null;
    }

    var stock = num(el.getAttribute('data-stock'));
    var label = el.getAttribute('data-label') || '';
    var sold = el.hasAttribute('data-sold') ? num(el.getAttribute('data-sold')) : (live && cfg.sold ? live.s : null);
    var card = ctx === 'card';

    var candidates = {
      carts: carts !== null && carts >= cfg.minCount && carts > 0 ? {
        n: carts,
        tpl: ctx === 'cart' ? cfg.textCart : card ? cfg.textCard : (carts === 1 ? cfg.textOne : cfg.textMany)
      } : null,
      stock: stock !== null && stock > 0 ? { n: stock, tpl: card ? cfg.textStockCard : cfg.textStock } : null,
      sold: sold !== null && sold > 0 && (preview || sold >= cfg.soldMin) ? { n: sold, tpl: card ? cfg.textSoldCard : cfg.textSold } : null,
      label: label ? { tpl: label, plain: true } : null
    };

    var order = preview ? [preview] : cfg.order;
    for (var i = 0; i < order.length; i++) {
      var pick = candidates[order[i]];
      if (pick && pick.tpl) { pick.kind = order[i]; return pick; }
    }
    return null;
  }

  /* ---------- rendering ---------- */
  function fillText(el, pick) {
    var target = el.querySelector('[data-gp-ca-text]');
    if (!target) return;
    target.textContent = '';
    if (pick.plain) { target.textContent = pick.tpl; return; }
    var parts = String(pick.tpl).replace(/\{days\}/g, String(cfg.soldDays)).split('{count}');
    parts.forEach(function (part, i) {
      if (part) target.appendChild(document.createTextNode(part));
      if (i < parts.length - 1) {
        var strong = document.createElement('strong');
        strong.className = 'gp-ca__count';
        strong.textContent = String(pick.n);
        target.appendChild(strong);
      }
    });
  }

  function apply(el, live) {
    var pick = choose(el, live);
    if (!pick) {
      el.hidden = true;
      el.removeAttribute('data-kind');
      return;
    }
    if (el.getAttribute('data-context') !== 'badge') fillText(el, pick);
    el.setAttribute('data-kind', pick.kind);
    el.hidden = false;
    if (cfg.animate && !reducedMotion) {
      // next frame so the transition actually runs
      requestAnimationFrame(function () { el.classList.add('gp-ca--in'); });
    } else {
      el.classList.add('gp-ca--in');
    }
  }

  /* ---------- batching + fetch ---------- */
  function needsLive(el) {
    if (!endpoint || el.hasAttribute('data-preview')) return false;
    // Metafield-style cart number already present and no sales wanted: nothing to ask.
    return !(el.hasAttribute('data-carts') && !cfg.sold);
  }

  function enqueue(el) {
    var id = el.getAttribute('data-product-id');
    if (!id || !needsLive(el)) { apply(el, null); return; }
    var hit = cached(id);
    if (hit) { apply(el, hit); return; }
    if (failed) { apply(el, null); return; }
    queue.push(el);
    if (!flushTimer) flushTimer = setTimeout(flush, BATCH_MS);
  }

  function flush() {
    flushTimer = null;
    var waiting = queue;
    queue = [];

    var ids = [];
    waiting.forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (!cached(id) && !inFlight[id] && ids.indexOf(id) === -1) ids.push(id);
    });

    // Elements whose id is already in flight are re-queued and picked up when it lands.
    var settle = function () {
      waiting.forEach(function (el) {
        var hit = cached(el.getAttribute('data-product-id'));
        if (hit) apply(el, hit);
        else if (failed) apply(el, null);
        else queue.push(el);
      });
      if (queue.length && !flushTimer) flushTimer = setTimeout(flush, BATCH_MS);
    };

    if (!ids.length) { settle(); return; }

    var chunks = [];
    for (var i = 0; i < ids.length; i += MAX_IDS_PER_REQUEST) chunks.push(ids.slice(i, i + MAX_IDS_PER_REQUEST));

    Promise.all(chunks.map(request)).then(settle, function () {
      // Worker unreachable: still show what doesn't need it (low stock, labels).
      failed = true;
      settle();
    });
  }

  function request(ids) {
    ids.forEach(function (id) { inFlight[id] = true; });

    var url = endpoint + '/counts?ids=' + encodeURIComponent(ids.join(',')) +
      '&window=' + encodeURIComponent(cfg.windowHours) +
      '&exclude=' + encodeURIComponent(cartToken()) +
      (cfg.sold ? '&days=' + encodeURIComponent(cfg.soldDays) : '');

    var controller = window.AbortController ? new AbortController() : null;
    var timeout = setTimeout(function () { if (controller) controller.abort(); }, REQUEST_TIMEOUT_MS);

    return fetch(url, { mode: 'cors', credentials: 'omit', signal: controller ? controller.signal : undefined })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        var counts = (json && json.counts) || {};
        var sold = json && json.sold;
        var now = Date.now();
        // Products absent from the response have zero carts / sales — cache that too.
        ids.forEach(function (id) {
          cache[id] = {
            c: num(counts[id]) || 0,
            s: sold ? (num(sold[id]) || 0) : null,
            t: now
          };
        });
        writeCache();
      })
      .finally(function () {
        clearTimeout(timeout);
        ids.forEach(function (id) { delete inFlight[id]; });
      });
  }

  /* ---------- custom element ---------- */
  // Using connectedCallback means elements inserted later — the cart drawer
  // re-rendering after an add, infinite scroll, quick view — fill themselves.
  if (!window.customElements.get('gp-cart-activity')) {
    window.customElements.define('gp-cart-activity', class extends HTMLElement {
      connectedCallback() {
        enqueue(this);
      }
    });
  }
})();
